import React from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Divider,
  Typography,
  Button,
  TextField,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { RHFInput } from 'react-hook-form-input'
import PropTypes from 'prop-types'

import useSnackbar from 'hooks/useSnackbar'

import { Label } from 'components'
import * as service from 'service'
import helpers from 'helpers'

import schema from './schema'

const JustifyDialog = ({
  open,
  setOpen,
  setLoading,
  setIsReopened,
  incident,
  refresh,
}) => {
  const snackbar = useSnackbar()
  const { errors, handleSubmit, register, setValue } = useForm({
    validationSchema: schema,
    defaultValues: {
      justify: '',
    },
  })

  const onSubmit = async (data) => {
    setLoading(true)

    try {
      await service.dponet.incidents.reopenLegalOpinion({
        incidentId: incident.id,
        ...data,
      })

      snackbar.open({
        message: 'Parecer reaberto com sucesso',
        variant: 'success',
      })

      setIsReopened(true)
      refresh()
    } catch (error) {
      console.error(error)

      snackbar.open({
        message:
          helpers.formatters.errorMessage(error) ||
          'Ocorreu um erro, tente novamente',
        variant: 'error',
      })
    } finally {
      setLoading(false)
      setOpen(false)
    }
  }

  const handleClose = () => setOpen(false)

  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={handleClose}>
      <DialogTitle>
        <Box>
          <Typography variant="h4">Reabrir parecer</Typography>
        </Box>
      </DialogTitle>
      <Divider />

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box mb={1}>
          <DialogContent>
            <Label
              title="Motivo da reabertura"
              description="Descreva o motivo da reabertura"
            >
              <RHFInput
                as={
                  <TextField
                    color="primary"
                    multiline
                    rows={3}
                    variant="outlined"
                    error={!!errors.justify}
                    helperText={<>{errors?.justify?.message}</>}
                    fullWidth
                  />
                }
                register={register}
                setValue={setValue}
                name="justify"
                mode="onBlur"
              />
            </Label>
          </DialogContent>
        </Box>
        <Divider />
        <DialogActions p={2}>
          <Box pl={2} pr={1}>
            <Button type="button" variant="outlined" onClick={handleClose}>
              Cancelar
            </Button>
          </Box>
          <Button variant="contained" type="submit" color="primary">
            Reabrir
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

JustifyDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  setLoading: PropTypes.func,
  setIsReopened: PropTypes.func,
  incident: PropTypes.object,
}

export default JustifyDialog
